import { FC } from 'react';

import { PageMetaSeo } from '@/components/page-seo-meta';
import { ISeoWrapperProps } from './seo-wrapper.interface';

const SeoWrapper: FC<ISeoWrapperProps> = ({ seoMetaData, currentUrlBase, jsonLdScript, children }) => (
  <>
    <PageMetaSeo currentUrlBase={currentUrlBase} seoMetaData={seoMetaData} jsonLdScript={jsonLdScript} />
    {children}
  </>
);

export default SeoWrapper;
